import React from "react";
import { InputAdornment, TextField } from "@mui/material";
import FormLabels from "../formLabel/FormLabels";
import "./inputField.scss"
import SearchIcon from "@mui/icons-material/Search";;

export function InputField({
  fullWidth,
  value,
  disabled,
  type,
  label,
  placeholder,
  onChange,
  isRequired,
  id,
  isError = false,
  errorMsg = "",
  name,
  isIcon=false,
  testId
}) {
  const resolvedTestId = testId || name || id || undefined;
  return (
    <div className="overideInputField" data-testid={resolvedTestId ? `${resolvedTestId}-wrapper` : undefined}>
      <div className="input_field_box">
        {label && (
          <FormLabels isRequired={isRequired} label={label}></FormLabels>
        )}
        <TextField
          id={id || undefined}
          style={{ width: "100%", margin: 0 }}
          variant="standard"
          placeholder={placeholder}
          autoComplete="off"
          disabled={disabled}
          type={type}
          value={value}
          className="formControlRoot"
          onChange={(e) => onChange(e)}
          fullWidth={fullWidth}
          size="small"
          InputProps={{
            className: "inputRoot",
            disableUnderline: true,
            
          startAdornment: isIcon && (
            <InputAdornment position="start">
            <SearchIcon className="icon"/>
            </InputAdornment>
          ),
          }}
          inputProps={{
            'data-testid': resolvedTestId
          }}
          error={isError}
          helperText={value ? "" : errorMsg}
          name={name}
        />
      </div>
    </div>
  );
}
